//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import { Container } from "vue-smooth-dnd";
import { applyDrag } from "../../utils/helpers";
import PlaylistContentCard from "../PlaylistContentCard.vue";
import AssignPlaylistModal from "./AssignPlaylistModal.vue";

export default {
  components: { Container, PlaylistContentCard, AssignPlaylistModal },
  props: ["group"],
  computed: {
    ...mapGetters([
          "getGroupPlaylists",
          "getMediaFilesForPlaylist",
		      "getDeviceAssignedPlaylistsByID",
    ]),
  },
	watch: { 
		group: function() {
			this.initGroupPlaylists();
		}
	},
  data() {
    return {
        playlists: [],
		    showPlaylistModal: false,
        // last removed item from on drop
        lastRemovedItem: null,
        dropPlaceholderOptions: {
            className: "drop-preview",
            animationDuration: "150",
            showOnTop: true,
        },
    };
  },
  created() {
	  this.initGroupPlaylists();
  },
  methods: {
	...mapActions([
      "updatePlaylistContentV2",
      "updateGroupPlaylists"
    ]),
  getChildPayload(index) {
    return { index: index, fromPlaylist: true };
  },
  togglePlaylistModal() {
    this.showPlaylistModal = true;
  },
  popupClosed() {
    this.showPlaylistModal = false;
    this.initGroupPlaylists();
  },
	initGroupPlaylists() {
    this.playlists = this.getGroupPlaylists(this.group.GID);
	},
  async removePlaylistFromGroup(id) {
    let playlistsFiltered = this.playlists.filter(playlist => playlist.ID !== id);
    playlistsFiltered = playlistsFiltered.map((playlist) => {
      return playlist.ID;
    })
    await this.updateGroupPlaylists({groupId: this.group.GID, playlistIds: playlistsFiltered});
    this.initGroupPlaylists();
  },
	onDrop(collection, dropResult, playlist) {
      const { removedIndex, addedIndex } = dropResult;
      const fromPlaylist = !!dropResult.payload.fromPlaylist;

      console.log(dropResult);

      let playlistContent = this.getMediaFilesForPlaylist(playlist);

      // check if we dropped a content from another playlist
      // this means that this function will be called many times
      // at least once for the add and once for the remove of the content
      if (fromPlaylist) {
        dropResult.payload = playlistContent[dropResult.payload.index];

        if (addedIndex !== null && removedIndex === null) {
          // we added sth

          if (!this.lastRemovedItem) {
            // save drop position
            this.lastAddedIndex = addedIndex;
            this.lastPlaylistToAddIndex = collection;

            // break function here (it will be called another time)
            return;
          } else {
            // we removed sth before the add action

            // add last removed item as current payload
            dropResult.payload = this.lastRemovedItem;
            this.lastRemovedItem = null;
          }
        } else if (addedIndex === null && removedIndex !== null) {
          // we removed sth

          if (this.lastPlaylistToAddIndex >= 0) {
            // we added sth before

            let allPlaylists = this.playlists;

            // avoid a vuex store mutation with json
            const contentIds = JSON.parse(
              JSON.stringify(
                allPlaylists[this.lastPlaylistToAddIndex].contentIds
              )
            );

            // add current content to given position
            contentIds.splice(this.lastAddedIndex, 0, dropResult.payload.id);

            this.updatePlaylistContentV2({
              content: contentIds,
              playlistId: allPlaylists[this.lastPlaylistToAddIndex].ID,
            });

            this.lastPlaylistToAddIndex = -1;
          } else {
            // save dropped item
            this.lastRemovedItem = dropResult.payload;
          }
        }
      }

      // add new media into current media files
      var tmp = applyDrag(playlistContent, dropResult);

      console.log(tmp);

      // get only the content ids of the new playlist
      let contentIds = [];
      tmp.forEach((content) => {
        if (content) {
          if (content.contentGroup) {
            contentIds.push(content.contentGroupId);
          } else {
            contentIds.push(content.id);
          }
        }
      });

      if (fromPlaylist || addedIndex != null) {
        // update playlist in db
        this.updatePlaylistContentV2({
          content: contentIds,
          playlistId: playlist.ID,
        });
      }
    },
  },
};
